import axios from 'axios';
import { REST_HOSTNAME } from '../Config';

const axiosInstance = axios.create({
    baseURL: REST_HOSTNAME
});

export interface ILogin {
    email: string | null;
    password: string | null;
    rememberMe: boolean | null;
}
export interface IRegister {
    email: string;
    password: string;
    confirmPassword: string;
    firstName: string;
    lastName: string;
    referrerSentenceScoreId: string | null;
    courseSignupCode?: string | null;
    studentInviteToken?: string | null;
}
export interface IToken {
    token: string;
}

export const LoginApi = {
    login: function (login: ILogin) {
        return axiosInstance.request<IToken>({
            method: "POST",
            url: `/login`,
            data: login
        });
    },
    register: function (register: IRegister) {
        return axiosInstance.request<boolean>({
            method: "POST",
            url: `/register`,
            data: register
        });
    },
    validateEmail: function (code: string) {
        // URL encode the code parameter
        const encodedCode = encodeURIComponent(code);

        // Construct the URL with the encoded code parameter
        return axiosInstance.request<boolean>({
            method: 'GET',
            url: `/validate_email?code=${encodedCode}`, // Use template literals to include the encoded code
        });
    },
    sendResetPasswordEmail: function (email: string) {
        return axiosInstance.request<string>({
            method: 'GET',
            url: `/reset_password_email?email=${encodeURIComponent(email)}`,
        });
    },
    /** Read-only: whether a reset link can still be used. Opening a link changes nothing. */
    checkResetPassword: function (code: string) {
        return axiosInstance.request<{ valid: boolean }>({
            method: 'GET',
            url: `/reset_password/check?code=${encodeURIComponent(code)}`,
        });
    },
    resetPassword: function (code: string, password: string, confirmPassword: string) {
        return axiosInstance.request<string>({
            method: 'POST',
            url: '/reset_password',
            data: { code, password, confirmPassword },
        });
    },
}
